import React from 'react';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { Includes } from './components/Includes';
import { ForWhom } from './components/ForWhom';
import { Benefits } from './components/Benefits';
import { ProductFormat } from './components/ProductFormat';
import { EmotionalClose } from './components/EmotionalClose';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-bronze-light selection:text-charcoal" data-id="element-0">
      <Hero data-id="element-1" />
      <Features data-id="element-2" />
      <Includes data-id="element-3" />
      <ForWhom data-id="element-4" />
      <Benefits data-id="element-5" />
      <ProductFormat data-id="element-6" />
      <EmotionalClose data-id="element-7" />
      <FAQ data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}